import { selectLocalPeer, selectPeers, useHMSStore } from "@100mslive/react-sdk";
import { useContext } from "react";
import React from "react";
import Peer from "./peer";

import { demoUsers } from "../../util/demoData.util";
import { WorkshopContext } from "../../contexts/workshop.context";

function Conference({ isLinear = false, smallSpace = false, demoWorkshop = false }) {
  let peers = useHMSStore(selectPeers);
  const localPeer = useHMSStore(selectLocalPeer);
  const { socket, user: { role, name } = {} } = useContext(WorkshopContext);

  if (localPeer?.roleName?.includes("sub-")) {
    peers = peers.filter((peer) => peer.roleName.includes(localPeer?.roleName));
  } else {
    peers = peers.filter((peer) => !peer.roleName.includes("sub-"));
  }
  if (demoWorkshop) {
    peers = [...demoUsers, { name, roleName: "participant", isLocal: true, demoUser: true }];
  }

  return (
    <div
      className={`flex gap-2 ${
        isLinear
          ? "flex-row flex-nowrap overflow-x-auto items-center justify-start"
          : smallSpace
            ? "flex flex-wrap gap-4 justify-center md:justify-start items-center"
            : "grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7"
      }`}>
      {/* {[...Array(11)].map(() => peers.map((peer) => <Peer key={peer.id} peer={peer} />))} */}
      {peers.map((peer) => (
        <Peer key={peer.id} peer={peer} />
      ))}
    </div>
  );
}

export default Conference;
